import React from 'react';
import './index.css';

// Packages
import { Link } from 'react-router-dom';

function FooterComponent() {
    return (
        <>
            <footer>
                © All rights reserved - <Link to="/terms">Terms</Link>
            </footer>
        </>
    );
}

export default FooterComponent;
